module.exports = __webpack_public_path__ + "img/logo-fa-botton-dark.abd781f.svg";